export default __webpack_public_path__ + "static/media/ic_vn_flag.9adb5896.svg";